<script setup lang="ts">
import { computed } from 'vue';
import { PropertyPurpose } from '@/helpers/const';
import IncomingPropertyReceiveRentalIncome from '@/components/application/incoming-property-receive-rental-income.vue';
import IncomingPropertyExpectedRentalIncome from '@/components/application/incoming-property-expected-rental-income.vue';
import type { PropertyPurposeType } from '@/types/api';

const props = defineProps<{
  id: string;
  propertyPurpose?: PropertyPurposeType;
  receiveRentalIncome?: boolean;
}>();

const showRentalIncomeQuestion = computed(() => props.propertyPurpose === PropertyPurpose.INVESTMENT_PROPERTY);
</script>

<template>
  <div class="mt-6">
    <IncomingPropertyReceiveRentalIncome
      v-if="showRentalIncomeQuestion"
      :id="`${id}-rental-income-question`"
      :data-test-id="`${id}-rental-income-question`"
      label="Does this property generate rental income?"
    />
    <IncomingPropertyExpectedRentalIncome
      v-if="showRentalIncomeQuestion && receiveRentalIncome"
      :id="`${id}-rental-income`"
      :data-test-id="`${id}-rental-income`"
    />
    <BxField v-slot="{ field }" name="outstandingLoanAmount">
      <BxNumberInput
        v-bind="field"
        :id="`${id}-outstanding-mortgage`"
        :data-test-id="`${id}-outstanding-mortgage`"
        label="Outstanding Mortgage"
        label-type="floating"
        leading-symbol="$"
        class="form-control"
        help-text="Please enter zero if there is no outstanding mortgage."
      />
    </BxField>
    <BxField v-slot="{ field }" name="supportingPropertyValue">
      <BxNumberInput
        v-bind="field"
        :id="`${id}-supporting-property-value`"
        :data-test-id="`${id}-supporting-property-value`"
        class="form-control"
        label="Estimated Valuation"
        label-type="floating"
        leading-symbol="$"
      />
    </BxField>
  </div>
</template>
